import {
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

export const modelNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize18,
    lineHeight: TextLineHeight.TextLineHeight22,
    fontWeight: TextWeight.bold,
  },
};

export const modelTrimNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight18,
    fontWeight: TextWeight.light,
    color: TextColor.primary
  },
};

export const modelPriceTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize24,
    lineHeight: TextLineHeight.TextLineHeight29,
    fontWeight: TextWeight.bold,
  },
};

export const modelMileageTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.bold,
    color: TextColor.inherit,
  },
};
export const modelWarrantyTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.p,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight32,
    color: TextColor.inherit,
    textAlign: TextAlignment.end,
  },
};

export const dealerNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.bold,
  },
};

export const dealerDistanceTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.sub,
  style: {
    fontSize: TextSize.TextSize12,
    lineHeight: TextLineHeight.TextLineHeight14,
    fontWeight: TextWeight.regular,
  },
};

export const dealerPhoneTextStyle: TextCustomProps = {
  appearance: TextAppearance.copy100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize14,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.bold,
    color: TextColor.inherit,
  },
};
